import Cookies from "universal-cookie";
import useInfiniteGet from "../read/useInfiniteGet";
import { COMPANY_ID, COMPANYNAME } from "../../config";

const cookies = new Cookies();

const useGetUserCompanies = ({ enabled = true, limit = 10, params = {} } = {}) => {
  const infiniteQuery = useInfiniteGet({
    url: "user/companies_list",
    key: ["user-companies-list-infinite"],
    enabled,
    limit,
    params,
    isIncludeCompanyId: true,
  });

  const companies =
    infiniteQuery.data?.pages?.flatMap((page) =>
      Array.isArray(page?.data)
        ? page.data
        : Array.isArray(page?.data?.data)
        ? page.data.data
        : []
    ) || [];

  const firstPage = infiniteQuery.data?.pages?.[0];
  const paginationData = firstPage?.pagination_data || firstPage?.pagination;
  const totalCount =
    paginationData?.total_count ||
    paginationData?.totalCount ||
    firstPage?.total_count ||
    firstPage?.totalCount ||
    0;

  const selectedAndDefault = firstPage?.selected_and_default || [];

  const activeCid = cookies.get(COMPANY_ID);
  const activeCname = cookies.get(COMPANYNAME);

  const selectedCompany =
    selectedAndDefault.find((c) => c.is_selected === true) ||
    (activeCid && activeCname
      ? { company_id: activeCid, company_name: activeCname }
      : null);

  const defaultCompany =
    selectedAndDefault.find((c) => c.default_company === true) || null;

  const isSameSelectedAndDefault = Boolean(
    selectedCompany &&
      defaultCompany &&
      String(selectedCompany?.company_id) === String(defaultCompany?.company_id)
  );

  return {
    ...infiniteQuery,
    companies,
    totalCount,
    paginationData,
    selectedAndDefault,
    selectedCompany,
    defaultCompany,
    isSameSelectedAndDefault,
  };
};

export default useGetUserCompanies;
